import React, { useState, useEffect } from 'react';
import ClassNames from 'classnames';
import PropTypes from 'prop-types';
import thumbnailService from '../../../../ts/2d/services/thumbnail2d';
import Thumbnail from '../components/Thumbnail';

function Thumbnail2dContainer({
  type,
  targetId,
  size,
  imgClassName,
  containerClass,
  format,
  altName,
  onLoad
}) {
  const [thumbnailStatus, setImageStatus] = useState(null);
  const [thumbnailUrl, setImageUrl] = useState(null);
  const errorIconClass = ClassNames(thumbnailService.getCssClass(thumbnailStatus));
  const [shimmerClass, setShimmerClass] = useState('shimmer');

  useEffect(() => {
    setShimmerClass('shimmer');
    setImageStatus(null);
    setImageUrl(null);

    let isUnmounted = false;

    thumbnailService
      .getThumbnailImage(type, targetId, size, format)
      .then(({ thumbnail: { state, imageUrl } }) => {
        if (!isUnmounted) {
          setImageStatus(state);
          setImageUrl(imageUrl);
          setShimmerClass('');
        }
      })
      .catch(err => {
        // eslint-disable-next-line no-console
        console.debug(err);
        if (!isUnmounted) {
          setShimmerClass('');
        }
      });

    return () => {
      isUnmounted = true;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [type, targetId, size, imgClassName]);

  return (
    <Thumbnail
      {...{
        thumbnailUrl,
        errorIconClass,
        imgClassName,
        altName,
        onLoad,
        containerClass: ClassNames(shimmerClass, containerClass)
      }}
    />
  );
}
Thumbnail2dContainer.defaultProps = {
  size: '150x150',
  imgClassName: '',
  containerClass: '',
  format: 'png',
  altName: '',
  onLoad: () => {}
};

Thumbnail2dContainer.propTypes = {
  type: PropTypes.string.isRequired,
  targetId: PropTypes.number.isRequired,
  size: PropTypes.string,
  format: PropTypes.string,
  imgClassName: PropTypes.string,
  containerClass: PropTypes.string,
  altName: PropTypes.string,
  onLoad: PropTypes.func
};

export default Thumbnail2dContainer;
